/* Angular */
import { createReducer, on } from '@ngrx/store';

/* Functions */
import { updateEntityInArray } from 'src/app/features/shared/functions';

/* actions */
import * as AppointmentDataStoreActions from './appointment-data-store.actions';

import { Appointment } from 'src/app/features/shared/models';

/* State key */
export const featureKey = 'AppointmentDataStore';

/* State interface */
export interface AppointmentState {
  isLoading?: boolean;
  appointments?: Appointment[];
  activeAppointment?: Appointment;
}

/* Initial values */
export const initialState: AppointmentState = {
  isLoading: null,
  appointments: null,
  activeAppointment: null,
};

export const reducer = createReducer(
  initialState,
  on(AppointmentDataStoreActions.GetAppointments, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(
    AppointmentDataStoreActions.GetAppointmentsSuccessful,
    (state, action) => ({
      ...state,
      appointments: action.payload.appointments,
      isLoading: false,
    }),
  ),

  on(AppointmentDataStoreActions.GetAppointmentsFailure, (state, action) => ({
    ...state,
    isLoading: false,
  })),

  on(AppointmentDataStoreActions.GetAppointmentById, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(
    AppointmentDataStoreActions.GetAppointmentByIdSuccessful,
    (state, action) => ({
      ...state,
      /* TODO: replace item by id from data array */
      isLoading: false,
    }),
  ),

  on(
    AppointmentDataStoreActions.GetAppointmentByIdFailure,
    (state, action) => ({
      ...state,
      isLoading: false,
    }),
  ),

  on(AppointmentDataStoreActions.CreateAppointment, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(
    AppointmentDataStoreActions.CreateAppointmentSuccessful,
    (state, action) => ({
      ...state,
      appointments: [...(state.appointments ?? []), action.payload.appointment],
      isLoading: false,
    }),
  ),

  on(AppointmentDataStoreActions.CreateAppointmentFailure, (state, action) => ({
    ...state,
    isLoading: false,
  })),

  on(AppointmentDataStoreActions.UpdateAppointment, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(
    AppointmentDataStoreActions.UpdateAppointmentSuccessful,
    (state, action) => ({
      ...state,
      appointments: updateEntityInArray<Appointment>(
        action.payload.id,
        action.payload.data,
        state.appointments ?? [],
      ),
      isLoading: false,
    }),
  ),

  on(AppointmentDataStoreActions.UpdateAppointmentFailure, (state, action) => ({
    ...state,
    isLoading: false,
  })),

  on(AppointmentDataStoreActions.DeleteAppointment, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(
    AppointmentDataStoreActions.DeleteAppointmentSuccessful,
    (state, action) => ({
      ...state,
      appointments:
        state.appointments?.filter((item) => action.payload.id !== item.id) ??
        [],
      isLoading: false,
    }),
  ),

  on(AppointmentDataStoreActions.DeleteAppointmentFailure, (state, action) => ({
    ...state,
    isLoading: false,
  })),

  on(AppointmentDataStoreActions.ResetState, () => initialState),
);
